<template>
    
</template>

<script>
    export default {
        name: "ServicesCategoriesInfo",
        homePageTopics: [
            {
                id: "text-understanding",
                path:"/admin/text-understanding",
                name: "homePage.textUnderstanding.header",
                description: "homePage.textUnderstanding.description",
                img: require("@/assets/img/services/textUnderstanding.png"),
                action: "this.loadHomePage(id)",
                selected: false,
                locked: false,
                children: [
                    {
                        id: "sentiment-analysis",
                        name: "homePage.textUnderstanding.children.sentimentAnalysis.header",
                        description: "homePage.textUnderstanding.children.sentimentAnalysis.description",
                        detailedDescription: "homePage.textUnderstanding.children.sentimentAnalysis.detailedDescription",
                        img: require("@/assets/img/services/sentimentAnalysis.png"),
                        goTo:"/text-understanding/sentiment-analysis",
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "question-answering",
                        name: "homePage.textUnderstanding.children.questionAnswering.header",
                        description: "homePage.textUnderstanding.children.questionAnswering.description",
                        goTo:"/text-understanding/question-answering",
                        img: require("@/assets/img/services/questionAnswering.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "text-summarization",
                        name: "homePage.textUnderstanding.children.textSummarization.header",
                        description: "homePage.textUnderstanding.children.textSummarization.description",
                        goTo:"/text-understanding/text-summarization",
                        img: require("@/assets/img/services/textSummarization.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "ner",
                        name: "homePage.textUnderstanding.children.ner.header",
                        description: "homePage.textUnderstanding.children.ner.description",
                        goTo:"/text-understanding/ner",
                        img: require("@/assets/img/services/ner.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "language-detection",
                        name: "homePage.textUnderstanding.children.languageDetection.header",
                        description: "homePage.textUnderstanding.children.languageDetection.description",
                        goTo:"/text-understanding/language-detection",
                        img: require("@/assets/img/services/languageDetection.png"),
                        selected: false,
                        locked: false,
                    },

                ]
            },
            {
                id: "text-classification",
                name: "homePage.textClassification.header",
                description: "homePage.textClassification.description",
                img: require("@/assets/img/services/textClassification.png"),
                action: "this.loadStatistics(id)",
                selected: false,
                locked: false,
                children: [
                    {
                        id: "classifier",
                        name: "homePage.textClassification.children.classifier.header",
                        goTo:"training/classification",
                        description: "homePage.textClassification.children.classifier.description",
                        img: require("@/assets/img/services/classification.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "ontology",
                        name: "homePage.textClassification.children.ontology.header",
                        description: "homePage.textClassification.children.ontology.description",
                        goTo: "training/synonyms",
                        img: require("@/assets/img/services/ontology.png"),
                        selected: false,
                        locked: false,
                    },
                ]
            },
            {
                id: "conversation",
                name: "homePage.conversation.header",
                description: "homePage.conversation.description",
                img: require("@/assets/img/services/conversation.png"),
                selected: false,
                locked: false,
                children: [
                    {
                        id: "chatbotTrain",
                        name: "homePage.conversation.children.chatbotTrain.header",
                        description: "homePage.conversation.children.chatbotTrain.description",
                        goTo:"training/dialogs",
                        img: require("@/assets/img/services/chatbotTrain.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "chatbotTest",
                        name: "homePage.conversation.children.chatbotTest.header",
                        description: "homePage.conversation.children.chatbotTest.description",
                        goTo:"testing/dialogs",
                        img: require("@/assets/img/services/chatbotTest.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "plugin",
                        name: "homePage.conversation.children.plugin.header",
                        description: "homePage.conversation.children.plugin.description",
                        goTo:"training/plugins",
                        img: require("@/assets/img/services/plugIn.png"),
                        selected: false,
                        locked: false,
                    },
                ]
            },
            {
                id: "storage",
                name: "homePage.storage.header",
                description: "homePage.storage.description",
                img: require("@/assets/img/services/storage.png"),
                selected: false,
                locked: false,
                children:[
                    {
                        id: "files-upload",
                        name: "homePage.storage.children.filesUpload.header",
                        description: "homePage.storage.children.filesUpload.description",
                        goTo: "training/files",
                        img: require("@/assets/img/services/filesUpload.png"),
                        selected: false,
                        locked: false,
                    },
                ]

            },
            {
                id: "search",
                name: "homePage.search.header",
                description: "homePage.search.description",
                img: require("@/assets/img/services/search.png"),
                selected: false,
                locked: false,
                children: [
                    {
                        id: "search",
                        name: "homePage.search.children.documentSearch.header",
                        description: "homePage.search.children.documentSearch.description",
                        goTo: "testing/files",
                        img: require("@/assets/img/services/documentSearch.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "documentSimilarity",
                        name: "homePage.search.children.documentSimilarity.header",
                        description: "homePage.search.children.documentSimilarity.description",
                        goTo: "testing/document-similarity",
                        img: require("@/assets/img/services/documentSimilarity.png"),
                        selected: false,
                        locked: false,
                    },
                ]
            },
            {
                id: "use-cases",
                name: "homePage.useCases.header",
                description: "homePage.useCases.description",
                img: require("@/assets/img/services/useCases.png"),
                selected: false,
                locked: false,
                children: [
                    {
                        id: "web-radar",
                        goTo:"web-radar",
                        name: "homePage.useCases.children.webRadar.header",
                        description: "homePage.useCases.children.webRadar.description",
                        img: require("@/assets/img/services/webRadar.png"),
                        selected: false,
                        locked: false,
                    },
                    {
                        id: "intelligent-mail-routing",
                        goTo:"training/emails",
                        name: "homePage.useCases.children.intelligentMailRouting.header",
                        description: "homePage.useCases.children.intelligentMailRouting.description",
                        img: require("@/assets/img/services/mailRouting.png"),
                        selected: false,
                        locked: false,
                    },
                ]
            },
            {
                id: "statistics",
                name: "homePage.statistics.header",
                description: "homePage.statistics.description",
                img: require("@/assets/img/services/statistics.png"),
                selected: false,
                locked: false,
                children:[
                    {
                        id: "dialogs",
                        title: "Dialogs",
                        name: "statistics.dialogs.header",
                        description: "statistics.dialogs.description",
                        goTo: 'statistics/reports/dialogs',
                        img: require("@/assets/img/services/chatbotTest.png"),
                        action: "this.loadStatistics(id)",
                        locked: false,
                    },
                    {
                        id: "mail",
                        title: "Mails",
                        name: "statistics.mail.header",
                        description: "statistics.mail.description",
                        goTo: 'statistics/reports/mail',
                        img: require("@/assets/img/services/mailRouting.png"),
                        action: "this.loadStatistics(id)",
                        locked: false,
                    },
                    /*{
                        id: "documents",
                        name: "statistics.documents.header",
                        description: "statistics.documents.description",
                        img: require("@/assets/img/training/statistics/documents.jpg"),
                        action: "this.loadStatistics(id)",
                        locked: true,
                    },
                    {
                        id: "classification",
                        name: "statistics.classification.header",
                        description: "statistics.classification.description",
                        img: require("@/assets/img/training/statistics/classification.jpg"),
                        action: "this.loadStatistics(id)",
                        locked: true,
                    },*/
                ]
            },
        ],

        methods: {
            getRequireImg(path) {
                console.log('require   : ----- ' + path);
                return require(path)
            },
            getLocalization(string) {
                return this.$t(string)
            },
        }
    }

</script>

<style scoped>

</style>